export const DATE_FIELD_ERROR = 'You can select date range max upto 90 days!'
export const CUSTOM_RANGE = 'Custom Range'